import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import IconChevronRight from '@spothero/icons/chevron-right';
import Link from 'router/Link';
import classNames from 'classnames';

function Breadcrumbs({items, className}) {
    const classes = classNames('Breadcrumbs', className);
    const children = items.map((item, index) => {
        const {link, label, active} = item;
        const itemClasses = classNames('Breadcrumbs-item', {active});

        return (
            <Fragment key={index}>
                {index !== 0 && <IconChevronRight className="Chevron" />}
                <div className={itemClasses}>
                    {link ? (
                        <Link to={link}>{label}</Link>
                    ) : (
                        <span>{label}</span>
                    )}
                </div>
            </Fragment>
        );
    });

    return <div className={classes}>{children}</div>;
}

Breadcrumbs.propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.string,
            label: PropTypes.string,
        })
    ).isRequired,
};

export default Breadcrumbs;
